import React, { Fragment } from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Services from '../../api/service';
import Bg from '../../images/shapes/bg_pattern_4.svg';

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const ServiceSinglePage = () => {
    const { slug } = useParams();
    
    // Find the service by slug
    const service = Services.find(s => s.slug === slug);
    
    // Get other services for sidebar (excluding current)
    const otherServices = Services.filter(s => s.slug !== slug && s.title).slice(0, 6);

    if (!service) {
        return (
            <Fragment>
                <Header />
                <main className="page_content">
                    <section className="page_banner_section text-center" style={{ backgroundImage: `url(${Bg})` }}>
                        <div className="container">
                            <h1 className="page_title mb-0 text-white">Service Not Found</h1>
                        </div>
                    </section>
                    <section className="section_space">
                        <div className="container text-center">
                            <p>The service you're looking for doesn't exist.</p>
                            <Link to="/service" className="btn btn-primary mt-3">
                                <span className="btn_label" data-text="View All Services">View All Services</span>
                            </Link>
                        </div>
                    </section>
                </main>
                <Footer />
                <Scrollbar />
            </Fragment>
        );
    }

    return (
        <Fragment>
            <Header />
            <main className="page_content">
                {/* Page Banner */}
                <section className="page_banner_section text-center" style={{ backgroundImage: `url(${Bg})` }}>
                    <div className="container">
                        <div className="heading_focus_text text-white">
                            Our
                            <span className="badge bg-secondary">Services</span>
                        </div>
                        <h1 className="page_title mb-0 text-white">{service.title}</h1>
                        {service.thumb1 && service.thumb2 && (
                            <p className="text-white mt-3 mb-0">
                                {service.thumb1} • {service.thumb2}
                            </p>
                        )}
                    </div>
                </section>

                {/* Service Details */}
                <section className="section_space">
                    <div className="container">
                        <div className="row">
                            {/* Main Content */}
                            <div className="col-lg-8">
                                {service.sImg && (
                                    <div className="mb-4">
                                        <img 
                                            src={service.sImg} 
                                            alt={service.title}
                                            className="img-fluid rounded"
                                            style={{ width: '100%', objectFit: 'contain' }}
                                        />
                                    </div>
                                )}
                                
                                <h2 className="mb-4">{service.title}</h2>
                                
                                {service.description && (
                                    <p className="text-muted mb-4" style={{ fontSize: '18px', lineHeight: '1.8' }}>
                                        {service.description}
                                    </p>
                                )}

                                {service.features && (
                                    <div className="mt-4">
                                        <h4 className="mb-3">Key Features</h4>
                                        <ul className="list-unstyled">
                                            {service.features.map((feature, index) => (
                                                <li key={index} className="mb-2">
                                                    <i className="fa-solid fa-check-circle text-primary me-2"></i>
                                                    {feature}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}

                                {/* Contact CTA */}
                                <div className="mt-5 p-4 bg-light rounded">
                                    <h4>Interested in this service?</h4>
                                    <p className="text-muted">Contact us today to discuss how we can help your business.</p>
                                    <Link onClick={ClickHandler} to="/contact" className="btn btn-primary">
                                        <span className="btn_label" data-text="Contact Us">Contact Us</span>
                                        <span className="btn_icon">
                                            <i className="fa-solid fa-arrow-up-right"></i>
                                        </span>
                                    </Link>
                                </div>
                            </div>

                            {/* Sidebar */}
                            <div className="col-lg-4">
                                <div className="p-4 bg-light rounded">
                                    <h4 className="mb-4">Other Services</h4>
                                    <ul className="list-unstyled">
                                        {otherServices.map((s, index) => (
                                            <li key={index} className="mb-3">
                                                <Link 
                                                    onClick={ClickHandler}
                                                    to={`/service-single/${s.slug}`}
                                                    className="d-flex align-items-center text-decoration-none"
                                                    style={{ color: 'inherit' }}
                                                >
                                                    <i className="fa-solid fa-chevron-right text-primary me-2"></i>
                                                    <span>{s.title}</span>
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                    <hr />
                                    <Link onClick={ClickHandler} to="/service" className="btn btn-outline-primary w-100">
                                        <span className="btn_label" data-text="View All Services">View All Services</span>
                                    </Link>
                                </div>

                                {/* Contact Info */}
                                <div className="p-4 bg-primary text-white rounded mt-4">
                                    <h4 className="text-white mb-3">Need Help?</h4>
                                    <p className="mb-3">Our team is ready to assist you with any questions.</p>
                                    <p className="mb-2">
                                        <i className="fa-solid fa-phone me-2"></i>
                                        +233 247073232
                                    </p>
                                    <p className="mb-0">
                                        <i className="fa-solid fa-envelope me-2"></i>
                                        info@kemstec.com
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    );
};

export default ServiceSinglePage;
